import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20m-27.212-1.37a3 3 0 0 0-4.243 4.243l5.657 5.657 2.121 2.121 2.122-2.12 13.2-13.2a3 3 0 0 0-4.244-4.243L16.325 22.166z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }